import { c as _c } from "react/compiler-runtime";
import FormItem from "forms/fields/FormItem";
import type { IDateValidator } from "forms/helpers/parseDateValidators";
import type { FormControlType } from "types/formType";
import type { IProperty } from "types/jsonSchema";
import type { IFormInputs } from "types/uiSchema";
import NativeDatePicker from "ui/NativeDatePicker/NativeDatePicker";
import { FormField } from "uiShadcn/form";
interface DatePickerProps {
  control: FormControlType;
  uiData: IFormInputs;
  jsonData: Record<string, IProperty>;
}
export default function DatePicker(t0) {
  const $ = _c(13);
  const {
    control,
    uiData,
    jsonData
  } = t0;
  const name = uiData["x-json-schema-reference-property"];
  let t1;
  if ($[0] !== uiData.required) {
    t1 = uiData?.required?.includes("true");
    $[0] = uiData.required;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRequired = t1;
  let t2;
  if ($[2] !== jsonData || $[3] !== name) {
    t2 = jsonData[name]?.["x-validators"] ?? [];
    $[2] = jsonData;
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const validators = t2 as unknown as IDateValidator;
  let t3;
  if ($[5] !== isRequired || $[6] !== uiData.description || $[7] !== validators) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem label={uiData.description} required={isRequired}><NativeDatePicker onValueChange={field.onChange} dataTestId={field.name} ref={field.ref} validators={validators} required={isRequired} value={field.value} label={uiData.description} /></FormItem>;
    };
    $[5] = isRequired;
    $[6] = uiData.description;
    $[7] = validators;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== control || $[10] !== name || $[11] !== t3) {
    t4 = <FormField control={control} name={name} render={t3} />;
    $[9] = control;
    $[10] = name;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}